export const CATEGORY_TERM__HOW_TO = 6261;
export const CATEGORY_TERM__WEBINAR = 6356;

/**
 * Builds out an array of term ids going back to the parent.
 *
 * Requires that all parents are present in the original term.
 *
 * @param taxonomy_term
 *   The taxonomy term.
 * @param tree
 *   A tree array.
 */
export function getTermTree(taxonomy_term, tree = []) {
  if (taxonomy_term && taxonomy_term.id !== 'virtual') {
    tree.push(taxonomy_term.id);
  }
  if (taxonomy_term.parent && taxonomy_term.parent[0]?.id) {
    getTermTree(taxonomy_term.parent[0])
  }

  return tree;
}